import { PhotoIcon } from '@heroicons/react/24/outline'

interface imgSelectProps {
    id: string
    selectedImgUrl: any
    onChange: any
}

const ImageUploader = ({ id, selectedImgUrl, onChange }: imgSelectProps) => {


    return (
        <>
            <div>
                <label htmlFor={id}>
                    <div className='w-full h-[200px] bg-midGreen bg-opacity-[10%] flex justify-center items-center border-[2px] border-midGreen border-dashed rounded-md cursor-pointer'>
                        {
                            selectedImgUrl ? <img src={selectedImgUrl} alt="mmg" className='h-full w-full object-cover' />
                                :
                                <PhotoIcon className='h-10 w-10 text-midGreen' />
                        }
                    </div>
                </label>
                <input id={id} type='file' className='hidden' accept="image/*" onChange={onChange} />
            </div>
        </>
    )
}

export default ImageUploader
